import { Component, OnInit } from '@angular/core';
import { GlobalServices } from '../global.services';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  submitted: boolean = false;
  contRes: boolean = false;
  form: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    email: new FormControl(''),
    mobile: new FormControl(''),
    comments: new FormControl(''),
  });
  constructor(private fb: FormBuilder, private globalService: GlobalServices, private httpService: ApiService) { }
  ngOnInit() {
    if (this.globalService.isBrowser) {
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
      this.globalService.createTabs();
    }
    this.form = this.fb.group(
      {
        firstName: ['', [Validators.required, Validators.minLength(3)]],
        lastName: ['', [Validators.required, Validators.minLength(3)]],
        email: ['', [Validators.required, Validators.email]],
        mobile: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
        comments: ['']
      }
    );
  }
  get f() {
    return this.form.controls;
  }
  public mode = '';
  public responseMessage = '';
  public showAlert = false;

  submitForm() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    } else {
      let url = "global/contact";
      this.mode = 'indeterminate';
      let data = this.form.value;
      this.httpService.postFormData(url, data).subscribe(response => {
        this.submitted = false;
        this.form.reset();
        this.mode = 'determinate';
        if (response.success) {
          this.contRes = true;
          this.showAlert = true;
          this.responseMessage = 'Your Form has been submitted successfully';
          if (this.globalService.isBrowser) {
            setTimeout(() => {
              this.contRes = false;
            }, 3000);
          }
        }
      })
    }
  }
  public triggerCloseEvent() {
    this.showAlert = false;
  }

}
